import HeaderFilter from '../../../components/HeaderFilter';
import WarehouseForm from './WarehouseForm';
import WarehouseTable from './WarehouseTable';

const WarehousePage = () => {
  const api = '/location/warehouses';

  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter />
        <WarehouseTable api={api} />
        <WarehouseForm api={api} />
      </div>
    </>
  );
};

export default WarehousePage;
